import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-modal-call',
  templateUrl: './modal-call.component.html',
  styleUrls: ['./modal-call.component.scss'],
})
export class ModalCallComponent implements OnInit {

  @Input() title: any;
  @Input() number: any;
  @Input() membership: any;
  @Input() contract_number: any;
  
  constructor(private modalController:ModalController, private platform: Platform) { }

  ngOnInit() {}

  call(){
    window.location.href = `tel:${this.number}`;
  }


  closeModal(){
    this.modalController.dismiss();
  }
}
